import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(saleAreaId, projectId, department) {
    const searchOptions = {
      limit: 10000000,
      page: 1,
    };
  
    // if (projectId){
    //   searchOptions.status = 'OPEN';
    // }
    const searchQueryParams = new URLSearchParams(searchOptions).toString();
    let searchQueryParamsProject = new URLSearchParams(searchOptions).toString();
    let searchQueryEmployeeDepartment = new URLSearchParams(searchOptions).toString();
  
    let searchSaleBlockQueryParams = searchQueryParams;
    if (saleAreaId)
      searchSaleBlockQueryParams =
        searchQueryParams + "&" + new URLSearchParams({ saleAreaId }).toString();
    if (projectId)
      searchQueryParamsProject =
        searchQueryParams + "&" + new URLSearchParams({ projectId }).toString() ;
    if(department){
      searchQueryEmployeeDepartment =
        searchQueryParams + "&" + new URLSearchParams({ department }).toString() ;
    }
    // Fetch constant data concurrently
    const [
      jobPositionSupportBussinesData,
      branchData,
      supportDepartmentData,
    ] = await Promise.all([
      clientAPI("get", "/jobPosition/allowType?type=0"),
      clientAPI("get", `/branch?${searchQueryParams}`),
      clientAPI("get", `/supportDepartment?${searchQueryParams}`),
    ]);
  
    // Index data by 'id' to improve lookup performance
    return {
      jobPositionSupportBussines: jobPositionSupportBussinesData?.items?.reduce(
        (acc, item) => ({ ...acc, [item._id]: item.name }),
        {}
      ),
      branches: branchData?.items?.reduce(
        (acc, item) => ({ ...acc, [item._id]: item.name }),
        {}
      ),
      supportDepartments: supportDepartmentData?.items?.reduce(
        (acc, item) => ({ ...acc, [item._id]: item.name }),
        {}
      ),
    };
  }

export function useCategories(saleAreaId, projectId, department, shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories11"],
    queryFn: () => fetchConstantData(),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
